import { MutationTree } from "vuex";
import { SiteState, ISite } from "@/types/site";
import { IPagination } from "@/types";

import { IAmountByCategory } from "@/types/amount_by_category";

const mutations: MutationTree<SiteState> = {
  pagination: (state, sites: IPagination<ISite[]>) => {
    state.pagination = sites;
  },
  single: (state, site: ISite) => {
    state.site = site;
  },
  amount: (state, amount: number) => {
    state.amount = amount;
  },
  byCategory: (state, amount_by_category: IAmountByCategory) => {
    state.amount_by_category = amount_by_category;
  },
  clear: state => {
    state.site = undefined;
    state.pagination = undefined;
    state.amount = 0;
    state.amount_by_category = undefined;
  }
};

export default mutations;
